<!--
 * @Author: ghy
 * @Date: 2023-07-19 10:59:21
 * @LastEditors: ghy
 * @LastEditTime: 2023-10-07 13:42:45
 * @Description: 
-->
<template>
  <div class="caseList">
    <div v-if="noData && caseList.length">
    <cus-title text="案例展示"></cus-title>
    <div class="select-box">
      <el-select v-model="countyId" clearable filterable placeholder="请选择区域" @change="selectSchList">
        <el-option
          v-for="item in countyList"
          :key="item.dictId"
          :label="item.dictName"
          :value="item.dictId"
        >
        </el-option>
      </el-select>
      <el-select v-model="schId" clearable filterable placeholder="请选择学校">
        <el-option
          v-for="item in schList"
          :key="item.schId"
          :label="item.schName"
          :value="item.schId"
        >
        </el-option>
      </el-select>
      <el-select v-model="caseSortId" clearable placeholder="请选择">
        <el-option
          v-for="item in gwCaseSortList"
          :key="item.dictId"
          :label="item.dictName"
          :value="item.dictId"
        >
        </el-option>
      </el-select>
      <el-button type="primary" style="float: right;" @click="search">搜索</el-button>
    </div>
    <div v-if="noData && caseList.length"> 
      <div class="img-box">
      <div
        class="img-box-item"
        v-for="item in caseList"
        :key="item.id"
        @click="toDetails(item)"
      >
        <img :src="item.src" alt="" />
        <span>{{ item.schName }}-{{ item.coverTitle }}</span>
        <p>{{ item.coverNote }}</p>
      </div>
    </div>
    <div class="pagination-box" v-if="total">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="pageNo"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="6"
      >
      </el-pagination>
    </div>
    </div>
  </div>
    <div class="empty" v-else>
      <!-- <div class="empty-text">
        暂无数据
      </div> -->
      <div id="app" class="construction-page">
    <div class="content">
      <h1>模块正在建设中</h1>
      <p>案例展示模块正在建设中，敬请期待！</p>
    </div>
  </div>
      <!--div class="empty-img">
        <img src="@/assets/wenjian.png" alt="" />
      </div-->
    </div>
  </div>
</template>

<script>
import {
  findCountyList,
  findSchPage,
  findGwCaseSortList,
  findGwCheckedCasePage,
} from "@/api/case";
import { getFileById } from "@/api/common";
export default {
  data() {
    return {
      countyList: [],
      schList:[],
      schId:"",
      countyId: "",
      caseList: [],
      pageNo: 1,
      pageSize: 6,
      total: null,
      caseSortId: "",
      gwCaseSortList: [],
      srcList:[],
      noData: false,
    };
  },
  mounted() {
    this.findCountyList();
    this.findGwCaseSortList();
    this.findGwCheckedCasePage();
  },
  methods: {
    selectSchList(){
      this.findSchPage()
    },
    async findCountyList() {
      const res = await findCountyList();
      this.countyList = res.data;
    },
    async findSchPage(){
      const res = await findSchPage({
        pageNo: 1,
        pageSize: 1000,
        countyId:this.countyId
      })
      this.schList = res.data.listData.content
    },
    async findGwCaseSortList() {
      const res = await findGwCaseSortList();
      this.gwCaseSortList = res.data.listData;
    },
    async findGwCheckedCasePage() {
      const res = await findGwCheckedCasePage({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        caseSortId:this.caseSortId,
        countyId:this.countyId,
        schId:this.schId
      });
      this.caseList = res.data.listData.content;
      this.caseList.forEach((v) => {
        if(v.coverFileId){
          this.getFileById(v);
        }
      });
      this.total = res.data.listData.totalElements;
    },
    async getFileById(item) {
      const res = await getFileById({
        fileId: item.coverFileId,
        moduleFlag:'case',
        downFlag:0
      });
      const src =
        "data:image/png;base64," +
        btoa(
          new Uint8Array(res.data).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ""
          )
        );
      this.$set(item, "src", src);
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.findGwCheckedCasePage();
    },
    toDetails(item) {
      let routeData = this.$router.resolve({
        path: "/caseDetails",
        query: {
          keyId: item.caseShowId,
        },
      });
      window.open(routeData.href, '_blank')
    },
    search(){
      this.findGwCheckedCasePage()
    }
  },
};
</script>

<style lang="less" scoped>
.caseList {
  width: 1400px;
  padding: 20px 129px;
  box-sizing: border-box;
  background: #fff;
  .select-box {
    margin-top: 34px;
  }
  .img-box {
    margin-top: 36px;
    display: flex;
    flex-wrap: wrap;
    .img-box-item {
      margin-bottom: 22px;
      margin-right: 70px;
      width: 330px;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      &:nth-child(3n) {
        margin-right: 0;
      }
      > img {
        width: 300px;
        height: 200px;
        object-fit: cover;
      }
      > span {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #bd1a2d;
        line-height: 21px;
        margin-top: 10px;
      }
      > p {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #aba0a0;
        line-height: 21px;
      }
    }
  }
  .pagination-box {
    display: flex;
    justify-content: center;
    margin-top: 66px;
  }
}
.empty {
  width: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .empty-text {
    margin-top: 50px;
  }
  .empty-img {
    margin-top: 70px;
    > img {
      width: 188px;
      height: 222px;
      object-fit: cover;
    }
  }
}
.construction-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f0f0f0; /* You can replace this with an image or a more sophisticated design */
}

.content {
  text-align: center;
}

h1 {
  color: #333;
}

p {
  color: #666;
}
</style>


// WEBPACK FOOTER //
// src/views/case/caseList.vue